import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import { Box, Button, Grid, styled, useTheme, useMediaQuery, } from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@sal/authentication.react";
const StyledNavLink = styled(NavLink)({
    display: "inline-flex",
    textDecoration: "none",
    textTransform: "uppercase",
    lineHeight: 1,
    color: "inherit",
});
export function HorizontalMenu({ items, backButtonText = "Back", onBackButtonClick, }) {
    const auth = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const tabletBreakpoint = useMediaQuery(theme.breakpoints.down("md"));
    const _onBackButtonClick = onBackButtonClick !== null && onBackButtonClick !== void 0 ? onBackButtonClick : (() => navigate(-1));
    const isRouteMenuMatch = items.find((x) => x.path.toLowerCase() === location.pathname.toLowerCase());
    return (_jsx(Grid, { container: true, gap: tabletBreakpoint ? 0 : 12, alignItems: isRouteMenuMatch ? "flex-end" : "center", justifyContent: tabletBreakpoint && isRouteMenuMatch ? "space-between" : "flex-start", sx: {
            minHeight: "100%",
            paddingTop: theme.spacing(tabletBreakpoint ? 4 : 0),
            paddingBottom: theme.spacing(tabletBreakpoint && !isRouteMenuMatch ? 4 : 0),
            paddingX: theme.spacing(tabletBreakpoint ? 4 : 0),
        }, children: isRouteMenuMatch ? (_jsx(_Fragment, { children: items
                .filter(({ securityContext, securityContextPermission }) => auth.userHasPermission(securityContext, securityContextPermission))
                .map(({ label, path }) => {
                const linkActive = location.pathname.toLowerCase() === path.toLowerCase();
                return (_jsx(Grid, { item: true, children: _jsx(Box, { paddingX: 4, paddingBottom: 3, sx: {
                            borderBottom: 4,
                            borderColor: linkActive ? "inherit" : "transparent",
                            fontWeight: linkActive ? 700 : 500,
                            "&:hover": {
                                borderColor: "inherit",
                            },
                        }, children: _jsx(StyledNavLink, { to: path, children: label }) }) }, path));
            }) })) : (_jsx(Grid, { item: true, children: _jsx(Button, { variant: "outlined", startIcon: _jsx(ArrowBackIosNewOutlined, {}), onClick: _onBackButtonClick, sx: {
                    color: "inherit",
                    borderColor: "inherit",
                    "&:hover": {
                        borderColor: "inherit",
                        color: "inherit",
                    },
                }, children: backButtonText }) })) }));
}
